// Data
const state = {
    activeBuild: {},
    activeMenu: "configure",
    activeTab: "case",
    activeSubtabs: {
        case: "case-options",
        cooling: "cooling-options",
        motherboard: "motherboard-options",
        gpu: "gpu-options",
        cpu: "cpu-options",
        psu: "psu-options",
        ram: "ram-options",
        storage: "ssd-options",
        rgbs: "rgbs-options",
        extras: "extra-options",
        peripherals: "peripheral-options",
        monitor: "monitor-options",
        color: "color-options",
        software: "software-options",
        services: "service-options"
    },
    previousBuild: {},
    buildPrice: 0,
    activeRules: [],
    disableRules: [],
    previousPartQuantity: 0,
    isPreventRule: false,
    isLoading: false,
    partDetails: {},
    sessionData: {},
    sessionGamesData: [],
    draftId: null,
    loadingText: 'CALCULATING',
    isUserCheckingOut: false,
    showLoadingOverlay: false,
    fromStep5: false
}

// Only mutate data (assigment)
const mutations = {
    CHANGE_ACTIVE_RULES(state, newRules) {
        state.activeRules = _.cloneDeep(newRules);

        newRules.forEach((rule) => {
            if (["disable", "disable-all"].includes(rule.ruleType)) {
                state.disableRules.push(rule);
            } else if (rule.ruleType == "enable") {
                const index = state.disableRules.findIndex((disable) => {
                    return disable.ruleType == "disable"
                        && disable.products.products_id == rule.products.products_id
                        && disable.products.id == rule.products.id;
                });

                if (index >= 0) {
                    state.disableRules.splice(index, 1);
                }
            } else if (rule.ruleType == "enable-all") {
                const index = state.disableRules.findIndex((disable) => {
                    return disable.ruleType == "disable-all"
                        && disable.partToChange == rule.partToChange;
                });

                if (index >= 0) {
                    state.disableRules.splice(index, 1);
                }
            }
        });
    },
    RESET_DISABLE_RULES(state) {
        state.disableRules = [];
    },
    CHANGE_ACTIVE_BUILD(state, activeBuild) {
        state.activeBuild = activeBuild;
    },
    CHANGE_PREVIOUS_BUILD(state, previousBuild) {
        state.previousBuild = _.cloneDeep(previousBuild);
    },
    CHANGE_BUILD_PRICE(state, buildPrice) {
        state.buildPrice = buildPrice;
    },
    CHANGE_PREVIOUS_PART_QUANTITY(state, previousPartQuantity) {
        state.previousPartQuantity = previousPartQuantity;
    },
    CHANGE_BUILD_PART(state, { partName, part }) {
        state.activeBuild[partName] = part;
    },
    PUSH_BUILD_PART(state, { partName, part }) {
        state.activeBuild[partName].push(part);
    },
    REMOVE_BUILD_PART(state, { partName, partIndex }) {
        state.activeBuild[partName].splice(partIndex, 1);
    },
    CHANGE_PREVENT_RULE_VALIDATOR(state, isPreventRule) {
        state.isPreventRule = isPreventRule;
    },
    CHANGE_LOADING_STATE(state, loadingState) {
        if (loadingState) {
            state.isLoading = loadingState;
        } else {
            state.isLoading = !state.isLoading;
        }
    },
    CHANGE_ACTIVE_MENU(state, activeMenu) {
        state.activeMenu = activeMenu;
    },
    CHANGE_ACTIVE_TAB(state, activeTab) {
        state.activeTab = activeTab;
    },
    CHANGE_ACTIVE_SUBTAB(state, activeSubtab) {
        state.activeSubtabs[state.activeTab] = activeSubtab;
    },
    CHANGE_PART_DETAILS(state, newpartDetails) {
        state.partDetails = _.cloneDeep(newpartDetails);
    },
    CHANGE_SESSION_DATA_INFO(state, sessionData) {
        state.sessionData = _.cloneDeep(sessionData);
    },
    CHANGE_SESSION_GAMES_DATA(state, sessionGamesData) {
        state.sessionGamesData = _.cloneDeep(sessionGamesData);
    },
    CHANGE_DRAFT_ID(state, draftId) {
        state.draftId = draftId;
    },
    CHANGE_LOADING_TEXT(state, loadingText) {
        state.loadingText = loadingText;
    },
    CHANGE_USER_CHECKING_OUT_VALUE(state, isUserCheckingOut) {
        state.isUserCheckingOut = isUserCheckingOut;
    },
    CHANGE_SHOW_LOADING_OVERLAY(state, payload) {
        state.showLoadingOverlay = payload;
    },
    SET_FROM_STEP_5(state, payload) {
        state.fromStep5 = payload;
    }
}

// Methods that calls mutations
const actions = {
    setBuildPrice({ commit }, buildPrice) {
        commit("CHANGE_BUILD_PRICE", buildPrice)
    },
    setActiveBuild({ commit }, activeBuild) {
        commit("CHANGE_ACTIVE_BUILD", activeBuild)
    },
    setPreviousBuild({ commit }, previousBuild) {
        commit("CHANGE_PREVIOUS_BUILD", previousBuild)
    },
    setPreviousPartQuantity({ commit }, previousPartQuantity) {
        commit("CHANGE_PREVIOUS_PART_QUANTITY", previousPartQuantity)
    },
    changeBuildPart({ commit }, { partName, part }) {
        commit("CHANGE_BUILD_PART", { partName, part });
    },
    changeActiveRules({ commit }, newRules) {
        commit("CHANGE_ACTIVE_RULES", newRules);
    },
    resetDisableRules({ commit }) {
        commit("RESET_DISABLE_RULES");
    },
    pushBuildPart({ commit }, { partName, part }) {
        commit("PUSH_BUILD_PART", { partName, part });
    },
    removeBuildPart({ commit }, { partName, partIndex }) {
        commit("REMOVE_BUILD_PART", { partName, partIndex });
    },
    changePreventRuleValidator({ commit }, isPreventRule) {
        commit("CHANGE_PREVENT_RULE_VALIDATOR", isPreventRule);
    },
    changeLoadingState({ commit }, loadingState) {
        commit("CHANGE_LOADING_STATE", loadingState);
    },
    changeActiveMenu({ commit }, activeMenu) {
        commit("CHANGE_ACTIVE_MENU", activeMenu)
    },
    changeActiveTab({ commit }, activeTab) {
        commit("CHANGE_ACTIVE_TAB", activeTab);
    },
    changeActiveSubtab({ commit }, activeSubtab) {
        commit("CHANGE_ACTIVE_SUBTAB", activeSubtab);
    },
    changePartDetails({ commit }, newpartDetails) {
        commit("CHANGE_PART_DETAILS", newpartDetails)
    },
    changeSessionDataInfo({ commit }, sessionData) {
        commit("CHANGE_SESSION_DATA_INFO", sessionData)
    },
    changeSessionGamesData({ commit }, sessionGamesData) {
        commit("CHANGE_SESSION_GAMES_DATA", sessionGamesData)
    },
    changeDraftId({ commit }, draftId) {
        commit("CHANGE_DRAFT_ID", draftId)
    },
    changeLoadingText({ commit }, loadingText) {
        commit("CHANGE_LOADING_TEXT", loadingText)
    },
    changeUserCheckingOutValue({ commit }, isUserCheckingOut) {
        commit("CHANGE_USER_CHECKING_OUT_VALUE", isUserCheckingOut)
    },
    changeShowLoadingOverlay({ commit }, state) {
        commit("CHANGE_SHOW_LOADING_OVERLAY", state);
    },
    setFromStep5({ commit }, state) {
        commit("SET_FROM_STEP_5", state);
    }
}

const getters = {
    resolutionText() {
        return state.sessionData.resolutionText || "";
    },
    previousBuild() {
        return state.previousBuild;
    },
    buildPrice() {
        return state.buildPrice;
    },
    activeRules() {
        return state.activeRules;
    },
    previousPartQuantity() {
        return state.previousPartQuantity;
    },
    isPreventRule() {
        return state.isPreventRule;
    },
    isLoading() {
        return state.isLoading;
    },
    activeTab() {
        return state.activeTab;
    },
    activeMenu() {
        return state.activeMenu;
    },
    partDetails() {
        return state.partDetails;
    },
    sessionData() {
        return state.sessionData;
    },
    sessionGamesData() {
        return state.sessionGamesData;
    },
    draftId() {
        return state.draftId;
    },
    loadingText() {
        return state.loadingText;
    },
    isUserCheckingOut() {
        return state.isUserCheckingOut;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
